import React, { FC } from 'react';
import { Autocomplete, TextField, Chip, MenuItem } from '@mui/material';

/* eslint-disable @typescript-eslint/no-explicit-any */
interface MuseumSelectProps {
  tComp: (key: string) => string;
  allDimuOwners: any[];
  selectedOwners: any[];
  handleOwnerCodesChanged: (owners: any[]) => void;
  getOptionLabel: (option: any) => string;
  autocompleteItemStyle: (selected: boolean) => any;
}
/* eslint-enable @typescript-eslint/no-explicit-any */

const MuseumSelect: FC<MuseumSelectProps> = ({
  tComp,
  allDimuOwners,
  selectedOwners,
  handleOwnerCodesChanged,
  getOptionLabel,
  autocompleteItemStyle,
}) => {
  const defaultAutocompleteItemStyle = (selected: boolean) => ({
    backgroundColor: selected ? 'rgba(0, 0, 0, 0.08)' : 'transparent',
  });

  return (
    <Autocomplete
      multiple
      options={allDimuOwners}
      getOptionLabel={getOptionLabel}
      value={selectedOwners}
      size='small'
      renderOption={(props, option, { selected }) => (
        <li
          {...props}
          style={autocompleteItemStyle ? autocompleteItemStyle(selected) : defaultAutocompleteItemStyle(selected)}>
          {getOptionLabel(option)}
        </li>
      )}
      fullWidth
      disableCloseOnSelect
      isOptionEqualToValue={(o, v) => o.identifier === v.identifier}
      renderInput={(params) => <TextField {...params} label={tComp('DMBlock.OwnerCodesLabel')} size='small' />}
      onChange={(_, v) => handleOwnerCodesChanged(v)}
      renderValue={(value, getItemProps) =>
        value.map((option, index) => (
          <Chip size='small' {...getItemProps({ index })} key={option.identifier} label={option.identifier} />
        ))
      }
    />
  );
};

export default MuseumSelect;
